//Header per detaje 

export const financialColumns = ["LedgerID", "LedgerName", "FinancialStatements", "BilanceSide", "Debit", "Credit", "Balance"];

export const financialMappings = {
    LedgerID: "Kodi",
    LedgerName: "Emri Llogarisë",
    FinancialStatements: "Pasqyrimi Financiar",
    BilanceSide: "Bilanci kontabel",
    Debit: "Debi",
    Credit: "Kredi",
    Balance: "Bilanci",
};


export const financialDetailColumns = ["ActionType", "LedgerNameSQ", "Comment", "Date", "Debit", "Credit", "Progressive"];

export const financialDetailMappings = {
    ActionType: "Tipi",
    LedgerNameSQ: "Emri Llogarisë",
    Comment: "Komenti",
    Date: "Data",
    Debit: "Debi",
    Credit: "Kredi",
    Progressive: "Progresive",
};

////////////////////////
export const raportColumns = ["Muaji", "Transaksione", "Vlera0", "Vlera8", "Vlera18", "TotalPaTVSH", "VleraMeTVSH"];

export const raportMappings = {
    Muaji: "Muaji",
    Transaksione: "Numri Transaksioneve",
    Vlera0: "Vlera 0",
    Vlera8: "Vlera 8",
    Vlera18: "Vlera 18",
    TotalPaTVSH: "Total pa TVSH",
    VleraMeTVSH: "Vlera me TVSH",
};


/////////////////////////
export const purchaseColumns = ["Muaji", "Transaksione", "Vlera0", "Vlera8", "Vlera18", "TotalPaTVSH", "Rivleresimi", "VleraPaRivleresim", "VleraMeTVSH"];

export const purchaseMappings = {
    Muaji: "Muaji",
    Transaksione: "Numri Transaksioneve",
    Vlera0: "Vlera 0",
    Vlera8: "Vlera 8",
    Vlera18: "Vlera 18",
    TotalPaTVSH: "Total pa TVSH",
    Rivleresimi: "Rivlersimi",
    VleraPaRivleresim: "Vlera pa Rivlersim",
    VleraMeTVSH: "Vlera me TVSH",
};

/////////////////////////
export const wagesColumns = ["Muaji", "Punonjes", "PagaNeto", "TatimiNePaga", "KontributiPunetorit", "KontributiPunedhenesit", "PagatBruto", "Gjithsej"];

export const wagesMappings = {
    Muaji: "Muaji",
    Punonjes: "Numri Punonjesve",
    PagaNeto: "Paga Neto",
    TatimiNePaga: "Tatimi ne Paga",
    KontributiPunetorit: "Kontributi Punetorit",
    KontributiPunedhenesit: "Kontributi Punedhenesit",
    PagatBruto: "Paga Bruto",
    Gjithsej: "Gjithsej",
};

/////////////////////////
export const rentColumns = ["Muaji", "Transaksione", "QirajaNeto", "TatimiNeQira", "Gjithsej"];

export const rentMappings = {
    Muaji: "Muaji",
    Transaksione: "Numri Transaksioneve",
    QirajaNeto: "Qiraja Neto",
    TatimiNeQira: "Tatimi ne Qira",
    Gjithsej: "Gjithsej",
};

/////////////////////////
export const exClassColumns = ["KlasifikimiShpenzimit", "Transaksione", "Vlera0", "Vlera8", "Vlera18", "TotalPaTVSH", "VleraMeTVSH"];

export const exClassMappings = {
    KlasifikimiShpenzimit: "Klasifikimi Shpenzimit",
    Transaksione: "Numri Transaksioneve",
    Vlera0: "Vlera 0",
    Vlera8: "Vlera 8",
    Vlera18: "Vlera 18",
    TotalPaTVSH: "Total pa TVSH",
    VleraMeTVSH: "Vlera me TVSH",
};


/////////////////////////
export const interesColumns = ["Sequence_no", "Muaji", "Transaksione", "Total"];

export const interesMappings = {
    Sequence_no: "Numri",
    Muaji: "Muaji",
    Transaksione: "Numri Transaksioneve",
    Total: "Totali",
};

/////////////////////////
export const assetColumns = ["Sequence_no", "Emertimi", "Date", "VleraBruto", "Zhvleresimi", "VleraNeto"];

export const assetMappings = {
    Sequence_no: "Numri",
    Emertimi: "Emertimi",
    Date: "Date",
    VleraBruto: "Vlera Bruto",
    Zhvleresimi: "Zhvlersimi",
    VleraNeto: "Vlera Neto"
};